import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card, CardMedia, Grid, Box } from '@mui/material';
import { useTheme } from '@emotion/react';

const NarrowEndUserContentEntryCard = ({ title, coverImageUrl, onClick }) => {
  const hasTitle = !!title;

  const theme = useTheme();

  const imgClassNames = classNames('narrowEndUserContentEntryCardImage', {
    withFilter: hasTitle,
  });

  return (
    <div>
      <Card
        onClick={(ev) => {
          ev.stopPropagation();
          onClick();
        }}
        sx={{
          width: 166,
          height: 155,
          minWidth: 166,
          borderRadius: '15px',
          margin: '6px',
          flexShrink: 0,
        }}
        style={{ backgroundColor: theme.palette.primary.cardBackground }}>
        <Box sx={{ position: 'relative' }}>
          {hasTitle && coverImageUrl && (
            <Grid item xs={12}>
              <CardMedia
                component="img"
                className={imgClassNames}
                image={coverImageUrl}
                alt=""
              />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </Grid>
          )}
          {!hasTitle && coverImageUrl && (
            <Grid item xs={12}>
              <CardMedia
                component="img"
                className={imgClassNames}
                image={coverImageUrl}
                alt=""
              />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </Grid>
          )}
          {hasTitle && !coverImageUrl && (
            <div>
              <div className={imgClassNames} />
              <div className="narrowEndUserContentEntryCardText">{title}</div>
            </div>
          )}
          {!hasTitle && !coverImageUrl && (
            <div>
              <div className={imgClassNames} />
            </div>
          )}
        </Box>
      </Card>
    </div>
  );
};

NarrowEndUserContentEntryCard.propTypes = {
  title: PropTypes.string.isRequired,
  coverImageUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

NarrowEndUserContentEntryCard.defaultProps = {
  coverImageUrl: null,
};

export default NarrowEndUserContentEntryCard;
